import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import './SMToolbar.css';

@inject('translationsStore')
@observer
export default class SMToolbar extends Component {
  render() {
    const { translationsStore } = this.props;
    return (
      <div className="SMToolbar">
        <span className="creationActions">
          <div className="SMToolbarButton" onClick={this.props.onCreate}>
            <div className="caption">
              {translationsStore.translate('serviceManagers.labelCreateServiceManager')}
            </div>
          </div>
        </span>
      </div>
    );
  }
}
